import { withForm } from '@/components/form';
import { SectionCard } from '@/components/ui';

import { defaultFormValues } from '../../contactSchema';

export const CzechFieldsSection = withForm({
  defaultValues: defaultFormValues,
  render: function CzechFieldsSection({ form }) {
    return (
      <SectionCard title="Czech-specific fields">
        <div className="ds-form-grid-3">
          <form.AppField name="czechFields.vokativ">
            {(field) => (
              <field.TextField label="Vocative (first name)" placeholder="e.g., Petře" />
            )}
          </form.AppField>
          <form.AppField name="czechFields.vokativSurname">
            {(field) => <field.TextField label="Vocative (surname)" placeholder="e.g., Nováku" />}
          </form.AppField>
          <form.AppField name="czechFields.nameday">
            {(field) => <field.TextField label="Name day" placeholder="e.g., 24.12" />}
          </form.AppField>
        </div>
      </SectionCard>
    );
  },
});
